import angular from 'angular';
import StateService from './StateService';

const dtState = 'dtState';
export default dtState;

angular.module(dtState, [])
    .service('StateService', StateService);
